function togglePaymentPage() {
  const buttonStandart = $('.payment-page__button-one')
  const buttonPremium = $('.payment-page__button-two')
  const rateStandatr = $('.payment-page__package-one')
  const ratePremium = $('.payment-page__package-two')
  const titleStandart = $('.payment-page__content-one')
  const titlePremium = $('.payment-page__content-two')

  buttonPremium.on('click', function() {
    $(this).parent().addClass('active');
    ratePremium.addClass('active');
    titlePremium.addClass('active');
    rateStandatr.removeClass('active');
    titleStandart.removeClass('active');
  })
  buttonStandart.on('click', function() {
    $(this).parent().removeClass('active');
    ratePremium.removeClass('active');
    titlePremium.removeClass('active');
    rateStandatr.addClass('active');
    titleStandart.addClass('active');
  })
}
togglePaymentPage()